import { useForm } from "react-hook-form";
import { useUpdateBodyMapEntryWithLogsMutation } from "../../../services/api/bodyMapApi";
import { isDocumentPickerAsset, ThrelsFileType } from "ui/types/ThrelsFileType";
import { convertToFile } from "ui/utils/fileUtils";
import { useDisplayToast } from "ui/hooks/useDisplayToast";

interface UpdateBodyMapEntryForm {
  comment: string;
  image: ThrelsFileType[];
}

interface Props {
  residentId: number;
  entryId: number;
  onSuccess?: () => void;
}

export function useUpdateBodyMapEntry({
  residentId,
  entryId,
  onSuccess,
}: Props) {
  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
    getValues,
  } = useForm<UpdateBodyMapEntryForm>({
    defaultValues: {
      comment: "",
      image: [],
    },
  });

  const [updateBodyMapEntry, { isLoading }] =
    useUpdateBodyMapEntryWithLogsMutation();

  const { showNewToast, showErrorToast } = useDisplayToast();

  const submit = handleSubmit(async (data) => {
    // if (!data.comment && !data.image[0]) return;

    const formData = new FormData();
    formData.append("comment", data.comment);

    const image = data.image[0];
    if (image && isDocumentPickerAsset(image)) {
      const files = convertToFile([image]);
      if (files.length === 0) return;
      formData.append("image", files[0]!);
    }

    try {
      await updateBodyMapEntry({
        residentId,
        entryId,
        formData,
      }).unwrap();

      showNewToast({
        title: "Body entry updated successfully",
        message: "The update has been added to the body entry successfully",
        type: "success",
      });
      if (onSuccess) onSuccess();
    } catch (error) {
      showErrorToast(error);
    }
  });

  return { control, submit, isLoading, isSubmitting, getValues };
}
